import React from 'react';
import {
    Button, Modal, Form, InputNumber, message
} from 'antd';
import { postWithdraw, getDefaultBankCard } from '@/api/wallet';
const clsPrefix = 'withdraw';

const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 14 },
}

// 立即提现表单
const CollectionCreateForm = Form.create()(
  class extends React.Component {

    render() {
      const {
        visible, onCancel, onCreate, form,
        defaultBankCard,
      } = this.props;
      const { getFieldDecorator } = form;
      return (
        <Modal
          visible={visible}
          title="提现申请"
          okText="确认"
          onCancel={onCancel}
          onOk={onCreate}
        >
          <Form layout="horizontal">
            <Form.Item label="金额" {...formItemLayout}>
              {getFieldDecorator('totalfee', {
                rules: [{ required: true, message: '请输入提现金额!' }],//待添加，和可提现金额比较
              })(
                <InputNumber
                  style={{
                    width: "110px",
                  }}
                  formatter={value => `￥ ${value}`}
                  min={0}
                />
              )}
              <span className="ant-form-text">（单位：元）</span>
            </Form.Item>
            <Form.Item label="银行卡" {...formItemLayout}> 
                <span>{defaultBankCard.bankAccountNo}({defaultBankCard.bankName})</span>
            </Form.Item>
          </Form>
        </Modal>
      );
    }
  }
);
  
// 立即提现按钮
class Immediately extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      defaultBankCard: {}
    }
  }

  getDefaultBankCard = (callback) => {
    getDefaultBankCard().then(data => {

      if (!data) {
        // to set 银行卡
        this.setState({ visible: false }, () => {
          message.info('请添加银行卡');
          this.props.onTabChange('3');
        });
        return;
      }

      this.setState({
        defaultBankCard: data,
      }, () => {
        callback();
      })
    })
  }

  showModal = () => {
    // 之所以放在这 是因为有可能换了银行卡
    this.getDefaultBankCard(() => {
      this.setState({ visible: true });
    })
  }

  handleCancel = () => {
    this.setState({ visible: false });
  }

  handleCreate = () => {
    const form = this.formRef.props.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      postWithdraw({
        ...values,
        bankno: this.state.defaultBankCard.bankAccountNo
      }).then(() => {
        message.success('发起成功');
      });

      form.resetFields();
      this.setState({ visible: false });
    });
  }

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  }

  render() {
    const { defaultBankCard } = this.state;
    return (
      <div>
        <Button 
          type="primary" 
          className={`${clsPrefix}-immediatelyBtn`}
          onClick={this.showModal}
          size="large"
        >
          立即提现
        </Button>
        <CollectionCreateForm
          wrappedComponentRef={this.saveFormRef}
          defaultBankCard={defaultBankCard}
          visible={this.state.visible}
          onCancel={this.handleCancel}
          onCreate={this.handleCreate}
        />
      </div>
    );
  }
}
  
export default Immediately;
